<template>
  <div class="publishers">
    <h1>
      Publishers
    </h1>

    <div class="publishers--commands">
      <a @click="open_publisher_dialog()" class="publishers--button">
        <i class="fi-plus"></i>
        Add publisher
      </a>
    </div>

    <table>
      <thead>
      <tr class="publishers--th">
        <th>ID</th>
        <th>Titel</th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="publisher in displayable_publishers"
          @click="open_publisher_dialog(publisher)"
          class="publishers--row">
        <td>{{ publisher.id }}</td>
        <td>{{ publisher.title }}</td>
      </tr>
      </tbody>
    </table>

    <publisher-dialog v-if="current_publisher"
                      :publisher="current_publisher"
                      @closed_requested="current_publisher = null">
    </publisher-dialog>

    <portal-target name="base-modal"></portal-target>
  </div>
</template>

<script>
import "./publishers.scss";
import PublisherDialog from "../publisher-dialog/publisher-dialog-app"
import axios from "axios"

export default {
  name: "publishers",
  props: {
    original_publishers: {
      required: true,
    },
  },
  components: {
    PublisherDialog,
  },
  data() {
    return {
      publishers: this.original_publishers,
      current_publisher: null,
    }
  },
  methods: {
    open_publisher_dialog(publisher = null) {
      if (publisher) {
        this.current_publisher = Object.assign({}, publisher)
      } else {
        this.current_publisher = {
          id: null,
          title: null,
        }
      }
    },
  },
  computed: {
    displayable_publishers() {
      return this.publishers.filter(publisher => {
        if (publisher.deleted) return
        if (!publisher.persisted) return
        return true
      }).sort((p1, p2) => {
        const name1 = p1.title.toLowerCase()
        const name2 = p2.title.toLowerCase()
        if (name1 < name2) {
          return -1
        } else {
          return 1
        }
      })
    }
  },
  channels: {
    PublisherRegisteredChannel: {
      received(publisher_json) {
        console.log("PublisherRegisteredChannel received")
        const publisher = JSON.parse(publisher_json);
        this.publishers.push(publisher)
        this.$cable.subscribe({
                                channel: 'PublisherUpdatedChannel',
                                id: publisher.id
                              });
        this.$cable.subscribe({
                                channel: 'PublisherDeletedChannel',
                                id: publisher.id
                              });
      },
    },
    PublisherUpdatedChannel: {
      received(publisher_json) {
        console.log("PublisherUpdatedChannel received")
        const received_publisher = JSON.parse(publisher_json);
        const publisher          = this.publishers.find(publisher => {
          return publisher.id === received_publisher.id
        })
        if (!publisher) return
        Object.assign(publisher, received_publisher);
        console.log("Publisher updated", publisher)
      },
    },
    PublisherDeletedChannel: {
      received(publisher_json) {
        console.log("PublisherDeletedChannel received")
        const received_publisher = JSON.parse(publisher_json);
        const index              = this.publishers.findIndex(publisher => {
          return publisher.id === received_publisher.id
        })
        if (index === -1) return
        this.publishers.splice(index, 1);
      },
    },
  },
  mounted() {
    this.$cable.subscribe({
      channel: 'PublisherRegisteredChannel',
      stream: "publisher_registered",
    })

    this.publishers.forEach((publisher => {
      this.$cable.subscribe({
        channel: 'PublisherUpdatedChannel',
        id: publisher.id
      });
      this.$cable.subscribe({
        channel: 'PublisherDeletedChannel',
        id: publisher.id
      });
    }))
  },
}
</script>
